import IndividualCircularLoader from '../../../../../components/Loader/IndividualCircularLoader';
import useCompany from '../../../useCompany';
import CompanyStatsBody from './CompanyStatsBody';
import CompanyStatsHeader from './CompanyStatsHeader';
import styles from './companyStatsTable.module.scss';

function CompanyStatsTable() {
  const { companyStats, companyStatsStatusPending } = useCompany();

  if (companyStatsStatusPending) {
    return <IndividualCircularLoader size={200} />;
  }
  return (
    <table className={styles.companyStatsTable}>
      <CompanyStatsHeader />
      <CompanyStatsBody companyStats={companyStats} />
    </table>
  );
}

export default CompanyStatsTable;
